import * as types from './types';
import type { Account2Config, SharedState } from './types';

export const fetchAppSettingsBegin = () => ({
  type: types.FETCH_APP_SETTINGS_BEGIN
});

export const fetchAppSettingsSuccess = (appSettings: SharedState['appSettings']) => ({
  type: types.FETCH_APP_SETTINGS_SUCCESS,
  payload: appSettings
});

export const fetchAppSettingsFailure = (error: unknown) => ({
  type: types.FETCH_APP_SETTINGS_FAILURE,
  payload: error
});

export const updateAppSettings = (payload: { Account2Config?: Partial<Account2Config> }) => ({
  type: types.UPDATE_APP_SETTINGS,
  payload
});
